import './legal-information.scss';
import {useTranslation} from "react-i18next";


const LegalInformation = () => {
    const {t} = useTranslation()
    return (
        <div className="LegalInformation">
            <div className={"textes-wrapper"}>
                <h3 className={"section-title"}>{t("legal.title")}</h3>
                <div className={"section-paragraph"}>
                </div>
            </div>
        </div>
    );
};

export default LegalInformation;
